import * as React from 'react'
import { Icon, IconType } from 'DVWebNodeUI'
import * as st from './subtitles.module.scss'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { safeBoolean } from '../../utils/utils';

export interface ISubtitlesBadgeProps {
  subtitles?: WpsRuntime.atv.wps.StringList
  isClosedCaption?: boolean
}

export const Subtitles = ({ subtitles, isClosedCaption }: ISubtitlesBadgeProps) => {
  const showSubtitles = Boolean(subtitles && subtitles.length || safeBoolean(isClosedCaption))
  return showSubtitles &&
    (<span data-automation-id="subtitles-badge">
      <Icon className={st.subtitlesLogo} use={IconType.SUBTITLES} />
    </span>) || null
}
